import { IRevenueSpendByAccountSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountSpendDetailsTableLang: IRevenueSpendByAccountSpendDetailsTableLang = {
	revenue_spend_by_account_spend_details_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_amount: 'Amount',
		column_percent: 'Percent, %',
		column_account: 'Account',
		column_kt_group: 'KT Group',
		column_agency: 'Agency',
		column_fake_type: 'Fake Type'
	}
}